import Vue from 'vue';
import store from '@/store';
import $ from 'jquery'

import AddStockModal from './AddStockModal.vue';

export default function(){
    let element = $(`<div id="gnzs-1c-amo__add-stock-modal-container"></div>`)
    $('body').append(element)

    new Vue({
        store,
        render: h => h(AddStockModal)
    }).$mount('#gnzs-1c-amo__add-stock-modal-container');
}